import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { RichUtils } from "draft-js";
import { Editor } from 'react-draft-wysiwyg';
export const RichTextEditor = (props)=>/*#__PURE__*/ _jsx("div", {
        className: "input-group flex-nowrap",
        children: /*#__PURE__*/ _jsx(Editor, {
            localization: {
                locale: 'nl'
            },
            placeholder: props.placeholder,
            wrapperClassName: "flex-grow-1 h-100 border-end",
            toolbarClassName: "bg-light border-0 border-bottom mb-0",
            editorClassName: "form-control border-0",
            editorStyle: {
                maxHeight: 200
            },
            toolbar: {
                options: [
                    'inline',
                    'emoji',
                    'remove',
                    'link'
                ],
                inline: {
                    inDropdown: false,
                    options: [
                        'bold',
                        'italic',
                        'underline',
                        'strikethrough'
                    ]
                },
                emoji: {
                    inDropdown: true
                },
                blockType: {
                    inDropdown: false,
                    options: [
                        'Blockquote'
                    ]
                }
            },
            readOnly: props.disabled,
            editorState: props.editorState,
            onEditorStateChange: props.onNewEditorState,
            onFocus: props.onFocus,
            stripPastedStyles: true,
            handleKeyCommand: (command, editorState)=>{
                const newState = RichUtils.handleKeyCommand(editorState, command);
                if (newState) {
                    props.onNewEditorState(newState);
                    return 'handled';
                }
                return 'not-handled';
            }
        })
    });
